import React from 'react';
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import { Link, useParams } from "react-router-dom";

const  PaymentFailed  = () => {

const { id } = useParams();
//  const handleRetryPayment = () => {
//     // Add your logic here to retry the payment
    
//         history.push({
//           pathname: `/digit-ui/citizen/profile`,
//           // search: `${item?.applicationNo}`
//         });
//         console.log('Retry payment logic goes here');
//   };
 
     
    return (
      <div className="payment-failed-container">
        <div  className="payment-failed-conterol">Payment Failed {id}</div>
        <ReportProblemIcon color="error" style={{width:"150px" , height:"130px"}} />
        <p>We're sorry, but your payment was not successful.</p>
        <p>Please try again later or contact support if the issue persists.</p>
        <Link to={`/digit-ui/citizen/profile`}>
        <button >Retry Payment</button>
        </Link>
        
      </div>
    );
  }

export default PaymentFailed;
